import { Component, Input, ViewChildren, ViewContainerRef, QueryList, EventEmitter, Output } from '@angular/core';
import {GenericValue} from 'hisng';
import { DYNAMIC_FIELD_ANCHOR } from 'app/fs/res/common/model/dynamic-content/constants';
import { ProviderManager } from 'app/fs/res/common/utils/provider-manager';

import { ResearchInfrastructure } from 'app/fs/res/research-infrastructure/model/research-infrastructure';

@Component( {
    selector: 'res-research-infrastructure-basic-data',
    templateUrl: './research-infrastructure-basic-data.component.html',
    providers: [ProviderManager.getComponentProvider(ResearchInfrastructureBasicDataComponent)],
} )
export class ResearchInfrastructureBasicDataComponent {
    @Input() researchInfrastructure: ResearchInfrastructure;
    @Input() researchInfrastructureAccesskinds: GenericValue[];

    @Output() infrastructureAccesskindsChange = new EventEmitter();
    @ViewChildren( DYNAMIC_FIELD_ANCHOR, { read: ViewContainerRef } ) fieldViewContainerList: QueryList<ViewContainerRef>;

    public onClear( field: string ) {
        switch ( field ) {
            case 'visibilityValue': this.researchInfrastructure.visibilityValue = null; break;
            default: console.log( 'ERROR: Unsupported field:', field );
        }
    }
    public onResearchInfrastructureAccesskindsChange( event: GenericValue[] ) {
        this.infrastructureAccesskindsChange.emit( event );
    }
}
